import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { motion } from 'framer-motion';
import { ShieldOff } from 'lucide-react';

export const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#080C0A' }}>
        <div className="inline-block w-12 h-12 border-2 border-t-transparent rounded-full animate-spin" style={{ borderColor: '#D4AF37', borderTopColor: 'transparent' }} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Check if user is admin
  if (user.role !== 'admin') {
    return (
      <div className="min-h-screen flex items-center justify-center p-6" style={{ background: '#080C0A' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center max-w-md"
        >
          <div className="w-20 h-20 mx-auto mb-6 rounded-2xl flex items-center justify-center" style={{ background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.3)' }}>
            <ShieldOff className="w-10 h-10" style={{ color: '#EF4444' }} />
          </div>
          <h1 className="text-3xl font-light mb-4" style={{ fontFamily: "'Playfair Display', serif", color: '#F8FAF9' }}>
            Access Denied
          </h1>
          <p className="mb-8" style={{ color: '#A3B8AC' }}>
            You don't have permission to access the admin dashboard. This area is restricted to administrators only.
          </p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => window.location.href = '/'}
            className="rounded-full px-8 py-3 font-medium transition-all"
            style={{ background: '#D4AF37', color: '#080C0A' }}
          >
            Return to Homepage
          </motion.button>
        </motion.div>
      </div>
    );
  }

  return children;
};
